import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 6h16","key":"svg-0"}],["path",{"d":"M6 12h12","key":"svg-1"}],["path",{"d":"M9 18h2","key":"svg-2"}],["path",{"d":"M15 18l2 2l4 -4","key":"svg-3"}]]

const IconFilter2Check = createReactComponent('outline', 'filter-2-check', 'Filter2Check', __iconNode);

export default IconFilter2Check;